import React from 'react';
import Helmet from 'react-helmet';

import Banner from '../../components/Banner';

import './_content-page.scss';


class ContentPageTemplate extends React.Component {

  componentDidMount() {
    const isBrowser = typeof window !== 'undefined';
    const AOS = isBrowser ? require('aos') : undefined;
    this.aos = AOS;
    this.aos.init();
  }

  componentDidUpdate (){
    this.aos.refresh();
  }

  render() {
    const post = this.props.data.markdownRemark;
    return (
      <main>
        <Banner
          title={post.frontmatter.title}
          tagline={post.frontmatter.tagline}
        />
        <div class="container"
          dangerouslySetInnerHTML={{ __html: post.html }}
        />
      </main>
    );
  }
}

export default ContentPageTemplate;

{/* <div class="container">
<Helmet title={`Your Blog Name - ${post.frontmatter.title}`} />
<div class="blog-post">
  <h1>
    {post.frontmatter.title}
  </h1>
  <div class="blog-post-content"
    dangerouslySetInnerHTML={{ __html: post.html }}
  />
</div>
</div> */}




// export default function Template({
//   data // this prop will be injected by the GraphQL query we'll write in a bit
// }) {
//   const { markdownRemark: post } = data; // data.markdownRemark holds our post data
//   return (
//     <main>
//       <Banner />
//       <div class="blog-post-container">
//         <Helmet title={`Your Blog Name - ${post.frontmatter.title}`} />
//         <div class="blog-post">
//           <h1>
//             {post.frontmatter.title}
//           </h1>
//           <div
//             class="blog-post-content"
//             dangerouslySetInnerHTML={{ __html: post.html }}
//           />
//         </div>
//       </div>
//     </main>
//   );
// }


export const pageQuery = graphql`
  query ContentPageByPath($path: String!) {
    markdownRemark(frontmatter: { path: { eq: $path } }) {
      html
      frontmatter {
        path
        title
        tagline
      }
    }
  }
`
;



// WEBPACK FOOTER //
// ./src/templates/content-page/index.js